"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.target = exports.tabIndex = exports.listRole = exports.keyPrefix = exports.defaultLength = exports.classes = void 0;
var classes = {
  container: 'bds-breadcrumb-container',
  item: 'bds-breadcrumb-item',
  lastItem: 'bds-breadcrumb-item-last',
  overflowItem: 'bds-breadcrumb-overflow-item',
  separator: 'bds-breadcrumb-item-separator'
};
exports.classes = classes;
var defaultLength = 3;
exports.defaultLength = defaultLength;
var keyPrefix = 'breadcrumbitem_';
exports.keyPrefix = keyPrefix;
var listRole = 'list';
exports.listRole = listRole;
var tabIndex = 0;
exports.tabIndex = tabIndex;
var target = '_blank';
exports.target = target;